import { render, staticRenderFns } from "./CreateParentModal.vue?vue&type=template&id=3c775307&scoped=true"
import script from "./CreateParentModal.vue?vue&type=script&lang=js"
export * from "./CreateParentModal.vue?vue&type=script&lang=js"
import style0 from "./CreateParentModal.vue?vue&type=style&index=0&id=3c775307&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c775307",
  null
  
)

export default component.exports